import React from 'react'
import { PageTitleContainer, PageTitleText } from './PageLayout.styles'

export const PageTitle = ({
  title,
  noBorder,
}: {
  title: string
  noBorder?: boolean
}): JSX.Element => {
  return (
    <PageTitleContainer $noBorder={noBorder}>
      <PageTitleText>{title}</PageTitleText>
    </PageTitleContainer>
  )
}
